import { render, staticRenderFns } from "./D3FolderDetail.vue?vue&type=template&id=466d943e"
import script from "./D3FolderDetail.vue?vue&type=script&lang=js"
export * from "./D3FolderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports